var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maladie"},[_vm._v(" "+_vm._s(_vm.maladie)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }